<template>
  <div>
    <el-row class="detail-header-wrap">
      <BaseHeader
          title="サイズマスタ"
          icon="dashboard"
          class="masterSize-header" />
      <span class="action_button">
        <div class="edit-button-wrap">
          <el-dropdown
              v-show="showActionButtonComponent"
              @command="actionCommand">
            <el-button size="small">
              アクション
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu
                slot="dropdown"
                class="header-action-menu">
              <el-dropdown-item
                  :disabled="$isFunctionDisabled(define.PermissionKeys.Master.Size.EDIT)"
                  :command="define.PRODUCT_SIZE_MODE.EDIT">
                編集
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <BaseButton v-show="showEditButton"
              @click="cancel()">
            キャンセル
          </BaseButton>
          <BaseButton v-show="showEditButton"
              :disabled="disableSaveButton"
              @click="save()">
            保存
          </BaseButton>
        </div>
      </span>
    </el-row>
    <BaseSearchConditionModal
        v-if="true"
        :no-condition="false"
        :keyword="searchKeyword"
        :is-and-search="isAndSearch"
        :conditions="searchConditions"
        :base-query="baseQuery"
        :store-path="storePath"
        :res-path="responsePath"
        :save-key="saveKey"
        @search="onSearch"
        @searched="onSearched" />
    <div class="base-table-list tab-list">
      <el-row class="add-row">
        <BaseButton v-show="showEditButton"
            @click="addRow()">
          行追加
        </BaseButton>
      </el-row>
      <div class="el-table">
        <div class="el-table__body-wrapper">
          <table
              ref="table"
              class="table">
            <thead>
              <tr class="header">
                <th class="is-leaf is-sortable width-30">サイズコード</th>
                <th class="is-leaf is-sortable width-70">サイズ名</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(val, index) in sizeList">
                <tr :key="index"
                    :data-id="`${index}`"
                    :class="{'moveable': mode === define.PRODUCT_SIZE_MODE.EDIT,
                             'hidRow': val.node.isActive !== 1}">
                  <td>
                    <BaseCell
                        :ref="`code_${index}`"
                        :properties="createTextAreaProp('code')"
                        :display-item="val.node"
                        :editable="val.node.id === ''" />
                  </td>
                  <td>
                    <div class="div-flex">
                      <BaseCell
                          :ref="`name_${index}`"
                          :properties="createTextAreaProp('name')"
                          :display-item="val.node"
                          class="width-50"
                          :editable="mode === define.PRODUCT_SIZE_MODE.EDIT
                            && !groupUsed(val.node)" />
                      <BaseCell
                          v-if="mode === define.PRODUCT_SIZE_MODE.EDIT
                            && groupUsed(val.node)"
                          :ref="`name_${index}`"
                          class="cell-msg"
                          :properties="createTextAreaProp('used')"
                          :display-item="val.node"
                          :editable="false" />
                      <BaseOperationTooltip
                          v-if="showTooltip && !groupUsed(val.node)"
                          :list="getTooltipList(index)"
                          class="operation-button"
                          placement="bottom-end" />
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
            <tr v-if="sizeList.length < 1">
              <td colspan="3"
                  class="td-empty">
                データなし
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .add-row {
    text-align: right;
    height: 35px;
  }
  .tab-list {
    padding-top: 0px !important;
  }
  .table {
    width: 100%;
  }
  .th-bottom {
    border-bottom: 1px solid #ebeef5;
  }
  .moveable {
  cursor: pointer;
  }
  .hidRow {
  display: none;
  }
  .td-empty {
    text-align: center !important;
    color: #909399 !important;
  }
  .div-flex {
    display: flex;
    justify-content: space-between;
  }
  .cell-msg {
    color: #e22908;
    text-align: right;
    margin-right: 10px;
  }
  .width-30 {
    width: 30%;
  }
  .width-50 {
    width: 50%;
  }
  .width-70 {
    width: 70%;
  }
</style>
<script>
import _ from 'lodash'
import Sortable from 'sortablejs'
import { mapState, mapGetters } from 'vuex'

import * as define from '@/define'
import * as query from '@/queries/master'
import common from '@/utils/common'
import compare from '@/utils/compareUtils'
import * as config from '@/config'
import message from '@/utils/message'

import x from '@/components/mixins/mixin'
import confirmDiscardOnLeave from '@/components/mixins/confirmDiscardOnLeave'
import BaseCell, { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseOperationTooltip from '@/components/molecules/BaseOperationTooltip'
import BaseSearchConditionModal from '@/components/organisms/BaseSearchConditionModal'
import BaseButton from '@/components/atoms/BaseButton'
import BaseHeader from '@/components/molecules/BaseHeader'
import detailUtil from '@/components/mixins/detailUtil'

const sizeValidationRules = (v) => {
  // サイズコードの重複チェック
  v.$validator.extend('codeDuplicateCheck', {
    getMessage: () => '同じサイズコードが存在します',
    validate: (data) => {
      if (v.sizeList.filter((val, key) => { return val.node.code === data }).length > 1) {
        return false
      }
      return true
    }
  })
}

export default {
  name: 'MasterSizeList',
  components: {
    BaseHeader,
    BaseCell,
    BaseButton,
    BaseSearchConditionModal,
    BaseOperationTooltip
  },
  mixins: [ x, confirmDiscardOnLeave, detailUtil ],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      isChanged: false,
      sizeList: [],
      originSizeList: [],
      sortAble: Object
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      mode: (state) => state.MasterSize.mode,
      searchKeyword: (state) => state.MasterSize.searchKeyword,
      isAndSearch: (state) => state.MasterSize.isAndSearch,
      searchConditions: (state) => state.MasterSize.searchConditions,
      tdLists: (state) => state.MasterSize.tdLists
    }),
    ...mapGetters({
    }),
    saveKey () {
      return 'masterSizeCondition'
    },
    storePath () {
      return 'MasterSize'
    },
    baseQuery () {
      return query.GRAPH_QL_QUERY_PRODUCT_SIZE_LIST
    },
    responsePath () {
      return 'data.sizeListItems.edges'
    },
    showActionButtonComponent () {
      return (this.showActionButton && (this.$isFunctionShown(define.PermissionKeys.Master.Size.EDIT)))
    },
    showTooltip () {
      return this.mode !== define.PRODUCT_SIZE_MODE.NORMAL
    },
    showActionButton () {
      return this.mode === define.PRODUCT_SIZE_MODE.NORMAL
    },
    showEditButton () {
      return this.mode !== define.PRODUCT_SIZE_MODE.NORMAL
    },
    disableSaveButton () {
      return !this.isChanged
    },
    editableValidIds () {
      return this.mode !== define.PRODUCT_SIZE_MODE.NORMAL
    }
  },
  watch: {
    sizeList: {
      handler: function (val, oldVal) {
        this.isChanged = this.$_ConfirmDiscardOnLeave_isChanged()
      },
      deep: true
    },
    mode: {
      handler: function (val, oldVal) {
        if (oldVal != null) {
          if (val === define.PRODUCT_SIZE_MODE.EDIT) {
            // 編集モードに切り替える場合
            this.originSizeList = _.cloneDeep(this.sizeList)
            // ソート出来るTABLEを設定する
            this.createSortTable()
            this.$_ConfirmDiscardOnLeave_watchStart(this.sizeList)
          } else {
            // 通常モードに切り替える場合
            this.sortAble.sort(this.sortAble.toArray().map(Number).sort((a, b) => a - b))
            // ソート出来るTABLEを削除
            this.sortAble.destroy()
            this.$_ConfirmDiscardOnLeave_watchEnd()
          }
        }
      },
      deep: true
    }
  },
  async created () {
    this.updateStore('mode', define.PRODUCT_SIZE_MODE.NORMAL)
    await this.getDetailData()
    // カスタムバリデーションルールを追加
    sizeValidationRules(this)
  },
  mounted () {
  },
  destroyed () {
    window.removeEventListener('beforeunload', this.onBeforeUnload)
  },
  methods: {
    /**
     * ドラッグTableを作成
     */
    createSortTable (oldIndex, newIndex) {
      const tbody = document.querySelector('.el-table__body-wrapper tbody')
      if (tbody == null) {
        return
      }
      this.sortAble = Sortable.create(tbody, {
        animation: 180,
        delay: 0,
        disabled: false,
        onEnd: evt => {
          // ソートした後、サイズリストのINDEXを再計算する
          this.sortIndex(this.sortAble.toArray())
        }
      })
    },
    /**
     * ドラッグした場合、サイズリストにのソートを再計算する.
     */
    sortIndex (sortOrder) {
      for (let i = 0; i < this.sizeList.length; i++) {
        const index = sortOrder.map(Number).indexOf(i)
        this.sizeList[i].node.displayOrder = index + 1
      }
    },
    onSearch (keyword, conditions) {
      this.$emit('search', keyword, conditions)
    },
    onSearched (result) {
      // 検索後、データを再取得、通常モードに戻る
      this.$emit('searched', result)
      this.sizeList = this.tdLists
      this.updateStore('mode', define.PRODUCT_SIZE_MODE.NORMAL)
    },
    /**
     * サイズグループに使用中かをチェックする.
     */
    groupUsed (node) {
      // サイズグループにサイズコードに紐づくレコードがある場合、使用中とみなす
      return node.sizeGroupItems.length > 0
    },
    /**
     * 画面項目を生成.
     * @param {Object} path 項目KEY
     */
    createTextAreaProp (path) {
      // サイズコード
      if (path === 'code') {
        return {
          type: 'String', elementType: ELEMENT_TYPE.INPUT,
          path: path, validateRule: 'required|max:50|codeDuplicateCheck', validateAs: 'サイズコード'
        }
      }
      // サイズ名
      if (path === 'name') {
        return {
          type: 'String', elementType: ELEMENT_TYPE.INPUT,
          path: path, validateRule: 'max:256', validateAs: 'サイズ名'
        }
      }
      // 使用中文字
      if (path === 'used') {
        return {
          type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT,
          path: 'サイズグループで使用されています', class: { bold: true, center: true }
        }
      }
    },
    /**
     * Tooltipの項目を返却する.
     * @param {Object} row 注文情報
     * @return {Array}
     */
    getTooltipList (index) {
      return [
        {
          title: '削除',
          click: () => this.deleteSize(index)
        }
      ]
    },
    onBeforeUnload (event) {
      if (this.isChanged) {
        // 変更有の場合、再読み込み確認ダイアログを表示する.
        event.returnValue = 'changed'
      }
    },

    /**
     * アクションボタン
     * @param {Number} mode モード
     */
    actionCommand: async function (mode) {
      switch (mode) {
        case define.PRODUCT_SIZE_MODE.EDIT:
          this.editSize()
          break
        default: {}
      }
    },

    /**
     * EDIT処理
     */
    async editSize () {
      // 編集モードは全検索は前提です
      if (this.searchKeyword !== '') {
        // 検索条件がある場合、確認メッセージを出す
        this.$confirm('編集モードでは全件表示されます', define.MESSAGE_TITLE, {
          confirmButtonText: 'OK',
          cancelButtonText: 'キャンセル',
          type: 'warning'
        }).then(async () => {
          // OKの場合、検索条件をクリアして、再検索を行う
          await this.updateStore('searchKeyword', '')
          await this.updateStore('isAndSearch', false)
          // 再検索
          await this.getDetailData()
          // 編集モードに切り替える
          this.updateStore('mode', define.PRODUCT_SIZE_MODE.EDIT)
        }).catch(() => {
          this.$notify.info('キャンセルしました。')
        })
      } else {
        // そもそもが全検索の場合、そのまま編集モードに切り替える
        this.updateStore('mode', define.PRODUCT_SIZE_MODE.EDIT)
      }
    },
    /**
     * 新規サイズ行を生成.
     */
    addRow () {
      this.sizeList.push({ node: { id: '', isActive: 1, displayOrder: '', code: '', name: '', sizeGroupItems: [] } })
      // フォーカス移動
      window.scroll({ top: this.$refs['table'].offsetHeight, behavior: 'smooth' })
    },
    /**
     * サイズ削除を行う
     * @param {Number} index インデックス
     */
    deleteSize (index) {
      // 追加行を削除する場合、そのまま削除する
      if (this.sizeList[index].node.id === '') {
        this.sizeList.splice(index, 1)
      } else {
        this.sizeList[index].node.isActive = 0
      }
    },
    /**
     * サイズ編集保存を行う
     */
    async save () {
      // チェック処理
      if (!await this.$validator.validate()) {
        return
      }

      // 保存を行う
      this.$confirm('保存しますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(async () => {
        try {
          this.$loadingService.show()
          // サイズ編集パラメータの作成
          const data = this.buildRequestForUpdate()
          // サイズ編集保存を行う
          await this.updateSizeApi(data)
          this.isChanged = false
          // 編集保存後、通常モードに切り替える
          this.updateStore('mode', define.PRODUCT_SIZE_MODE.NORMAL)
          // 保存後、リスト再検索を行う
          await this.getDetailData()
          this.$notify.success('保存しました。')
        } catch (error) {
          const data = _.get(error, 'response.data')
          if (data == null) {
            common.addError(error, { msg: message.MSG_502() })
          } else {
            common.addError(error, { msg: message.MSG_545() })
          }
          this.$notify.error({ error: error })
          throw error
        } finally {
          this.$loadingService.close()
        }
      }).catch(() => {
        this.$notify.info('キャンセルしました。')
      })
    },
    /**
     * サイズ編集キャンセルを行う
     */
    async cancel () {
      const cancelEdit = () => {
        this.updateStore('mode', define.PRODUCT_SIZE_MODE.NORMAL)
        this.isChanged = false
      }
      if (!this.isChanged) {
        cancelEdit()
        return
      }
      this.$confirm('サイズ変更を破棄しますか？',
        define.MESSAGE_TITLE,
        {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          type: 'warning'
        }
      ).then(() => {
        // キャンセル後、リスト再検索を行う
        this.getDetailData()
        cancelEdit()
      }).catch(() => {
      })
    },
    /**
     * サイズマスタ情報を取得する。
     */
    async getDetailData () {
      try {
        this.$loadingService.show()
        // 検索SQLを作成する
        const queryQL = common.addGraphQlCondition(query.GRAPH_QL_QUERY_PRODUCT_SIZE_LIST, { keyword: this.searchKeyword })
        // サイズ検索APIを呼び出す
        const res = await common.postGraphQl(queryQL)
        // DBから画面の情報を取得
        this.sizeList = res.data.data.sizeListItems.edges
        this.originSizeList = _.cloneDeep(this.sizeList)
      } catch (error) {
        throw error
      } finally {
        this.$loadingService.close()
      }
    },
    /**
     * 一覧 からサイズ更新APIのリクエストパラメータを作成する.
     * originDataとの差分のみ戻り値とする.
     */
    buildRequestForUpdate () {
      let requestData = []

      const diffList = compare.diff(this.originSizeList, this.sizeList)
      for (const index in diffList) {
        requestData.push(
          {
            code: this.sizeList[index].node.code, // サイズコード
            name: this.sizeList[index].node.name, // サイズ名
            sortIndex: this.sizeList[index].node.displayOrder, // サイズ表示順
            delete: this.sizeList[index].node.isActive === 0 ? 1 : 0 // 有効フラグ（有効）
          })
      }
      return requestData
    },
    /**
     * サイズ更新 APIを呼び出す
     */
    async updateSizeApi (requestData) {
      const data = {
        sizes: requestData
      }
      const url = config.PRODUCT_SIZE_URL
      const method = 'post'
      const response = await common.apiAxios(url, { method, data })
      return response
    },
    /**
     * ストアの情報を更新する
     */
    updateStore (key, val) {
      const storeKey = `MasterSize/${key}`
      this.$store.commit({
        type: 'set',
        states: {
          [storeKey]: val
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/product/master/MasterSizeTop.vue